<template>
  <b-card>
    <b-row>
      <b-col
        cols="12"
        md="3"
        sm="6"
        v-for="param in params"
        v-bind:key="param.field"
      >
        <b-form-group :label="param.label">
          <NumberSeprator
            v-if="param.type == 'number'"
            v-model="param.value"
            :disabled="param.disabled"
          ></NumberSeprator>
        </b-form-group>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col cols="12" md="4" sm="4">
        <b-form-group label="بانک مبدا">
          <b-form-select
            v-model="transaction.from"
            :options="loadedBankList"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4" sm="4">
        <b-form-group label="بانک مقصد">
          <b-form-select
            v-model="transaction.to"
            :options="loadedBankList"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4" sm="4">
        <b-form-group label="مبلغ (ریال):">
          <NumberSeprator v-model="transaction.amount"> </NumberSeprator>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" md="2" sm="2">
        <b-button block>انصراف</b-button>
      </b-col>
      <b-col cols="12" md="2" sm="2">
        <b-button
          block
          @click="Payment"
          variant="success"
          :class="isBusy ? 'spinner spinner-light spinner-right' : ''"
          >ثبت و پرداخت</b-button
        >
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET_BANK_LIST } from "@/core/services/store/getBankList.module";
import { INTER_BANK_PAYMENT } from "@/core/services/store/interBankPayment.module";
import httpHelper from "../../helpers/httpHelper";
import TableShowData from "../../components/table";
import NumberSeprator from "@/components/numberSeprator";
export default {
  name: "InterbankTransaction",
  data() {
    return {
      url: "creditors",
      transactions_created_at: "",
      transaction: { from: null, to: null, amount: null },
      isBusy: false,
      params: [
        {
          label: "موجودی بانک سامان (ریال)",
          field: "BalanceSaman",
          type: "number",
          value: "",
          disabled: true,
        },
        {
          label: "موجودی بانک سامان 2 (ریال)",
          field: "BalanceSaman2",
          type: "number",
          value: "",
          disabled: true,
        },
        {
          label: "موجودی بانک صادرات (ریال)",
          field: "BalanceSaderat",
          type: "number",
          value: "",
          disabled: true,
        },
        {
          label: "موجودی بانک ملی",
          field: "BalanceMeli",
          type: "number",
          value: "",
          disabled: true,
        },
      ],
      loadedBankList: [],
    };
  },
  components: {
    "list-table": TableShowData,
    NumberSeprator,
  },
  methods: {
    loadedBalanceSam() {
      this.$store.dispatch(GET_BANK_LIST).then((loadedBankList) => {
        this.loadedBankList = loadedBankList;
        loadedBankList.forEach((element, index) => {
          httpHelper
            .getData(`sharing/get_balance/${element.title}`)
            .then((res) => {
              if (!res.result.url.match("https://")) {
                this.params[index].value =
                  Number(res.result.balance).toLocaleString() + " ریال";
              } else {
                this.$makeToast(
                  "danger",
                  "مشاهده موجودی بانک ملی",
                  "برای مشاهده موجودی اینجا کلیک کنید.",
                  7000,
                  res.result.url
                );
              }
            });
        });
      });
    },
    Payment() {
      this.isBusy = true;
      if (
        this.transaction.from != null &&
        this.transaction.to != null &&
        this.transaction.amount != null
      ) {
        this.$store
          .dispatch(INTER_BANK_PAYMENT, this.transaction)
          .then((data) => {
            this.isBusy = false;
            if (data.success === true) {
              if (typeof data.result === "object") {
                this.$makeToast(
                  "success",
                  "انتقال موفق",
                  "عملیات انتقال با موفقیت انجام شد.",
                  5000
                );
                this.transaction = { from: null, to: null, amount: null };
                this.loadedBalanceSam();
              } else {
                this.$makeToast(
                  "danger",
                  "صفحه لاگین بانک ملی",
                  "برای لاگین شدن به بانک ملی روی لینک همین متن کلیک کنید.",
                  7000,
                  data.result
                );
              }
            } else {
              this.$makeToast(
                "danger",
                "خطا",
                `${data.error[0]} ${data.error[1].message}`,
                7000
              );
            }
          })
          .catch((error) => {
            this.isBusy = false;
            this.$makeToast("danger", "خطا", error.message, 4000);
          });
      } else {
        this.isBusy = false;
        this.$makeToast(
          "danger",
          "هشدار",
          "اطلاعات وارد شده صحیح نمی باشد.",
          4000
        );
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "انتقال وجه بین بانکی" }]);

    this.loadedBalanceSam();
  },
};
</script>